export default __webpack_public_path__ + "pdf/Tobias_Isenberg.97bfffd.pdf";